export default __webpack_public_path__ + "static/media/6.4f01d556.png";